var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminNewSubmissions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#BF83FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_5675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1482 39.5069C31.1482 38.9792 31.1979 38.4628 31.2918 37.962H18.9542C18.4364 37.962 18.0167 37.5422 18.0167 37.0245C18.0167 36.5067 18.4364 36.087 18.9542 36.087H31.8799C32.2429 35.2802 32.73 34.541 33.3169 33.8938C33.2214 33.9267 33.1192 33.9453 33.0126 33.9453H18.9542C17.7166 33.9015 17.708 32.1176 18.9542 32.0703H33.0125C33.6439 32.0582 34.1146 32.7212 33.8985 33.3122C35.0205 32.2946 36.4192 31.5771 37.9667 31.2868V20.9578C37.9667 19.2932 36.6108 18.012 35.0208 18.012H32.3951C32.2711 20.1741 30.4735 21.8953 28.2809 21.8953H23.6858C21.4932 21.8953 19.6956 20.1741 19.5716 18.012H16.9459C15.3558 18.012 14 19.2933 14 20.9578V43.0495C14 44.7105 15.3531 45.9953 16.9459 45.9953H34.2409C32.3551 44.4605 31.1482 42.1222 31.1482 39.5069ZM18.9542 24.037H33.0126C33.5303 24.037 33.9501 24.4567 33.9501 24.9745C33.9501 25.4922 33.5303 25.912 33.0126 25.912H18.9542C17.7159 25.8679 17.7086 24.0841 18.9542 24.037ZM18.9542 28.0536H33.0126C33.5303 28.0536 33.9501 28.4734 33.9501 28.9911C33.9501 29.5089 33.5303 29.9286 33.0126 29.9286H18.9542C17.7159 29.8846 17.7086 28.1008 18.9542 28.0536ZM23.975 41.9787H18.9542C17.7133 41.9333 17.7111 40.1499 18.9542 40.1037H23.975C24.4928 40.1037 24.9125 40.5234 24.9125 41.0412C24.9125 41.5589 24.4928 41.9787 23.975 41.9787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6858 20.0203H28.2809C31.3653 19.8821 31.2018 15.451 28.1135 15.527C27.4233 13.4969 24.5426 13.4981 23.8533 15.527C20.7774 15.4453 20.5906 19.8744 23.6858 20.0203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5115 33.0186C35.9338 33.0186 33.0231 35.9292 33.0231 39.5069C33.3493 48.1029 45.675 48.1006 45.9999 39.5069C45.9999 35.9292 43.0893 33.0186 39.5115 33.0186ZM42.121 38.872L39.5258 41.4672C39.1597 41.8334 38.5662 41.8334 38.2001 41.4674L36.9022 40.17C36.0564 39.2599 37.3165 37.998 38.2278 38.8439L38.8628 39.4786L40.7953 37.5462C41.7059 36.7002 42.9669 37.9614 42.121 38.872Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_5675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminNewSubmissions);
export default __webpack_public_path__ + "static/media/adminNewSubmissions.b7df6037133c0d149f4b418f662cc4d1.svg";
export { ForwardRef as ReactComponent };